<script>
  import Box from '@components/List/Box'
  import { globalComputed } from "@store/helpers";
  import { conditionList } from "@utils/is-condition";
  export default {
    components: {
      Box
    },
    data() {
      return {
        // menuList: [
        //   {
        //     name: '代理品牌',
        //     to: {
        //       name: 'brand-list',
        //     },
        //     iconClass: "brand",
        //     icon: '<i class="icomoon icon-primary-brand"></i>',
        //   },
        //   {
        //     name: '解決方案',
        //     to: {
        //       name: 'solution-list'
        //     },
        //     iconClass: "solution",
        //     icon: '<i class="icomoon icon-primary-solution"></i>',
        //   },
        //   {
        //     name: '關於零壹',
        //     to: {
        //       name: 'about-menu'
        //     },
        //     iconClass: "about",
        //     icon: null,
        //     img: require('@assets/images/icon/icon-about.svg'),
        //     // icon: `<img src="${require('@assets/images/icon/icon-about.svg')}" alt="" width="35" class="pb-2">`,
        //   },
        // ]
      }
    },
    computed: {
      ...globalComputed,
      foramtLineId() {
        return (this.currentSetting.lineId || '').replace('@', '')
      },
      menuList() {
        return conditionList([
          {
            name: 'FaceBook',
            icon: '<i class="fab fa-facebook-square color-primary"></i>',
            href: this.currentSetting.fbFanpageUrl,
            condition: () => {
              return !!this.currentSetting.fbFanpageUrl
            }
          },
          {
            name: 'Line',
            icon: '<i class="fab fa-line color-primary"></i>',
            href: `https://line.me/R/ti/p/%40${this.foramtLineId}`,
            condition: () => {
              return !!this.currentSetting.lineId
            }
          },
          {
            name: 'Podcast',
            icon: '<i class="far fa-podcast color-primary"></i>',
            href: this.currentSetting.podcast,
            condition: () => {
              return !!this.currentSetting.podcast
            }
          },
          {
            name: 'Youtube',
            icon: '<i class="fab fa-youtube color-primary"></i>',
            href: this.currentSetting.youtubeUrl,
            condition: () => {
              return !!this.currentSetting.youtubeUrl
            }
          },
        ]);
      }
    },
    methods: {
      goToView(name) {
        this.$router.push(name)
      },
    }
  }
</script>
<template>
  <section class="pt-4" :class="$style.SectionMobileMenuBox">
    <div class="container">
      <div class="sectionMobileMenuBox__menuList row mobileGutter">
        <template
          v-for="(menu, index) in menuList"
        >
          <Box
            :key="`menu-${index}`"
            class="socialMenu col-6"
            :item="menu"
          />
        </template>
        <div class="col-12">
          <p class="mt-3 text-center color-gray-6 text-sm">© Zero One Tech. 2022 <br> All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" module>
  .SectionMobileMenuBox {
    padding-bottom: 4rem;
    :global {
      .sectionMobileMenuBox {
        &__menuList {
          &__item {

          }
        }
      }
    }
  }
</style>
